/** Join truthy class fragments with spaces. Falsy values are dropped. */
export function cx(...args: (string | false | null | undefined)[]): string {
  return args.filter(Boolean).join(" ");
}

/**
 * The canonical keyboard-focus ring (DESIGN-SYSTEM.md §1) — mandatory on every
 * interactive control. `Button`/`IconButton`/`TabHandle` already bake it in;
 * this constant is for the deliberately BESPOKE controls (board glass chips,
 * dev HUD toggles, list rows, swatches) so they opt into the one ring instead
 * of each re-typing the five classes — the drift the kit exists to kill.
 */
export const FOCUS_RING =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-500 " +
  "focus-visible:ring-offset-2 focus-visible:ring-offset-slate-950";
